module.exports = __webpack_public_path__ + "static/media/invoOverview.b9764b51.webp";


//////////////////
// WEBPACK FOOTER
// ./src/img/optimized/invoOverview.webp
// module id = 235
// module chunks = 0